import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    description: 'Header for UPS Invoiced activation modal shown before label purchase',
    defaultMessage: 'Activate Carrier',
    id: '/yUQFg',
  },
  subtitle: {
    description: 'Subtitle for UPS Invoiced activation modal explaining what will happen',
    defaultMessage: 'Activate your exclusive <b>UPS Invoiced by ShipStation</b> rates. Confirm the details below to begin shipping.',
    id: 'wgGMPX',
  },
  infoBanner: {
    description: 'Informational banner about UPS Invoiced payment terms',
    defaultMessage: 'Just add a credit card for easy invoice payments (net 0-day terms).',
    id: '7g7hYJ',
  },
  paymentMethodHelperText: {
    description: 'Helper text shown beneath the payment method picker explaining impact on Freight payment',
    defaultMessage: 'If applicable, this will update your Freight Shipping payment method.',
    id: 'uc2cvN',
  },
  autoPayLabel: {
    description: 'Label for the automatic payment authorization checkbox on the UPS Invoiced activation modal',
    defaultMessage: 'I authorize automatic payments for shipping charges.',
    id: 'h4UCxS',
  },
  autoPayDescription: {
    description: 'Detailed description of the automatic payment authorization for UPS Invoiced shipping',
    defaultMessage:
      'By checking this box, you authorize ShipStation to automatically charge your selected payment method for all your invoiced shipping costs incurred through your ShipStation account.',
    id: 'b1h/KG',
  },
  readOnlyNote: {
    description: 'Message shown to users without billing permissions explaining they cannot add a payment method',
    defaultMessage:
      'You do not have permission to activate UPS Invoiced by ShipStation. Reach out to your administrator to activate this carrier.',
    id: '7oX14T',
  },
  cancel: {
    description: 'Cancel button on UPS Invoiced activation modal',
    defaultMessage: 'Cancel',
    id: 'gwGMi5',
  },
  activate: {
    description: 'Activate button on UPS Invoiced activation modal, saves payment method and continues label purchase',
    defaultMessage: 'Activate',
    id: 'gUjAeY',
  },
  activateError: {
    description: 'Error notification when activating the UPS Invoiced carrier fails',
    defaultMessage: 'Failed to activate carrier. Please try again.',
    id: 'BPoxUH',
  },
  saveBillingAddress: {
    description: 'Save button label for the inline billing address form on the UPS Invoiced activation modal',
    defaultMessage: 'Save',
    id: '+eIUnL',
  },
});
